import React from 'react';
import { FileMinus, RotateCw } from 'lucide-react';
import '../../styles/components/no-data.scss';

class NoData extends React.Component {
  render() {
    const { message = 'No records found', actionText, onAction } = this.props;

    return (
      <div className="no-data-container">
        <FileMinus className="no-data-icon" />
        <p className="no-data-message">{message}</p>
        {actionText && (
          <button className="button1 button1-secondary" onClick={onAction}>
            <RotateCw className="refresh-icon" />
            {actionText}
          </button>
        )}
      </div>
    );
  }
}

export default NoData;
